import type { FC, ReactNode } from 'react'
import type { StoreBase } from '@/types'

import { CartProvider } from './cart-context'
import { MascotProvider } from './mascot-context'
import { StageProvider } from './stage-context'
import { CartDrawer } from './cart-drawer'
import { MascotAssistant } from './mascot-assistant'

interface StoreShellProps {
    store?: StoreBase | null
    children: ReactNode
}

/* Everything that lives across storefront pages: cart, mascot and the 3D stage */
export const StoreShell: FC<StoreShellProps> = ({ store, children }): ReactNode => {
    return (
        <CartProvider>
            <MascotProvider>
                <StageProvider>
                    {children}
                    <CartDrawer />
                    <MascotAssistant store={store} />
                </StageProvider>
            </MascotProvider>
        </CartProvider>
    )
}
